import Drawer from 'components/Drawer'
import { Form } from 'components/UIComponents/FormStyles'
import React from 'react'
import AddRoundConformDrawer from '../ConfirmDrawer/Partials/index'

const ConfirmDrawer = ({
  form,
  setConfirmDrawer,
  setRoundConfromDrawer,
  roundConfromDrawer,
  sortedItems,
  getDriveRoleMetrics,
  expcandidatesId,
  getDriveRoleCandidatesList,
  driveId,
  roleId,
  currentPage,
  stage,
  getRoleMetrics,
  isEditCondition,
  setIsEditCondition,
}) => {
  const onClose = async () => {
    setRoundConfromDrawer(false)
    getDriveRoleMetrics(expcandidatesId)
    await getDriveRoleCandidatesList({
      driveId: driveId,
      roleId: roleId,
      currentPage,
      stage,
    })
    getRoleMetrics(driveId, roleId)
  }
  const itemsWithNoId = sortedItems.filter(item => !item.id)
  const content = () => {
    return (
      <Form scrollToFirstError id={'addUserForm'} form={form} layout="vertical">
        <AddRoundConformDrawer
          setConfirmDrawer={setConfirmDrawer}
          form={form}
          setRoundConfromDrawer={setRoundConfromDrawer}
          roundConfromDrawer={roundConfromDrawer}
          itemsWithNoId={itemsWithNoId}
          getDriveRoleMetrics={getDriveRoleMetrics}
          expcandidatesId={expcandidatesId}
          getDriveRoleCandidatesList={getDriveRoleCandidatesList}
          driveId={driveId}
          roleId={roleId}
          currentPage={currentPage}
          stage={stage}
          getRoleMetrics={getRoleMetrics}
          isEditCondition={isEditCondition}
          setIsEditCondition={setIsEditCondition}
        />
      </Form>
    )
  }

  return (
    <Drawer
      width="43%"
      title={'Manage Interview Rounds'}
      placement="right"
      padding="30px"
      headerpadding="16px 30px"
      closable
      onClose={onClose}
      visible={roundConfromDrawer}
      content={content()}
    />
  )
}

export default ConfirmDrawer
